import React from 'react';

import Styles from './NavigationButton.module.scss';

import LeftArrow from '@/assets/svg/calendar-left-arrow.svg?react';
import RightArrow from '@/assets/svg/calendar-right-arrow.svg?react';

interface Props extends React.ComponentPropsWithRef<'div'> {
	direction: 'left' | 'right';
	tooltip?: string;
}

const NavigationButton = ({ direction, tooltip, ...rest }: Props) => {
	return (
		<div {...rest} className={Styles.container} title={tooltip}>
			{direction === 'left' ? <LeftArrow /> : <RightArrow />}
		</div>
	);
};

export default NavigationButton;
